import React, { useContext, useEffect, useRef, useState } from 'react'
import nrt_logo from '../../assets/images/nrt_logo.png'
import sidebar_image from '../../assets/images/sidebar_image.png'
import icon_user from '../../assets/images/icon_user.png'
import hamburger_icon from '../../assets/images/hamburger_icon.png'
import mobile_mrime1 from '../../assets/images/mobile_mrime1.png'
import mobile_mrime2 from '../../assets/images/mobile_mrime2.png'
import mobile_mrime3 from '../../assets/images/mobile_mrime3.png'
import { Link, useLocation } from 'react-router-dom'
import top_bar_icon from '../../assets/images/top_bar_icon.png'
import LoginContext from '../../context'
import MobileSidebar from '../MobileSidebar'

const MobileNavbar = () => {
    const [openSidebar, setSidebar] = useState(false)
    const [openMenuSidebar, setMenuSidebar] = useState(false)
    const sideMenuRef = useRef(null)
    const profileBtnRef = useRef(null)
    const { isAuthenticated, openLoginPopup } = useContext(LoginContext)

    const handleOpenSidebar = () => {
        setSidebar(true)
    }
    const handleCloseSidebar = () => {
        setSidebar(false)
    }

    const handleOpenMenuSidebar = () => {
        if (isAuthenticated) {
            setMenuSidebar(true)
        }
        else {
            openLoginPopup()
        }
    }

    const handleCloseMenuSidebar = () => {
        setMenuSidebar(false)
    }
    useEffect(() => {
        const handleOutSideClick = (e) => {
            if (isAuthenticated && sideMenuRef.current && !sideMenuRef.current.contains(e.target) && profileBtnRef.current && !profileBtnRef.current.contains(e.target)) {
                setMenuSidebar(false)
            }
        }

        document.addEventListener('click', handleOutSideClick)
        return () => {
            document.removeEventListener('click', handleOutSideClick)
        }
    }, [isAuthenticated])

    const location = useLocation();
    useEffect(() => {   
        handleCloseSidebar()
    }, [location]);

    return (
        <>
            <nav className='fixed top-0 left-0 w-full z-[999] h-[80px] shadow-[0px_1px_0px_rgba(255,255,255,0.1)] bg-gradient-to-b from-[#000000] to-[#0a0000] border-b border-b-navyBlue flex lg:hidden justify-between items-center px-[15px]'>
                <button className='p-2.5' onClick={handleOpenMenuSidebar} ref={profileBtnRef}> <img src={icon_user} alt="" className='h-[30px] w-[30px]' /> </button>
                <Link to='/' className='block'><img src={nrt_logo} alt="" className='w-[100px]  mx-auto ' /></Link>
                <button className='p-2.5' onClick={handleOpenSidebar}> <img src={hamburger_icon} alt="" className='h-[30px] w-[30px]' />  </button>
            </nav>
            <div className={`${openSidebar ? 'right-0' : 'right-[-100%]'} w-[90%] shadow-[-10px_0_30px_rgba(0,0,0,0.6)] fixed h-[100vh] top-0  bg-obsidian overflow-auto transition-all duration-300 ease-in-out z-[9999]`}>
                <div className={`w-full flex ${isAuthenticated ? 'justify-between' : 'justify-end'}  items-center pe-[15px]`}>
                    {isAuthenticated &&
                        <ul className="flex justify-between items-center w-[97%] font-sans-serif ">
                            <li className='leading-[35px]  text-center yexy-white mx-[2%] '>
                                <a href="#" className='text-white text-xs font-bold flex justify-center items-center'>
                                    <span className="">
                                        <img src={top_bar_icon} className='w-[25px] me-1' />
                                    </span>
                                    <span id="mb_nick"> panhok</span>님
                                </a>
                            </li>
                            <li className='leading-[35px] text-center yexy-white mx-[2%] '>
                                <a href="#" className='text-white text-xs font-bold'>
                                    <i className="fa fa-envelope text-white me-1"></i>
                                    <strong >쪽지 : 0 통</strong>
                                </a>
                            </li>
                        </ul>
                    }
                    <button className='w-fit  h-10 ' onClick={handleCloseSidebar} > <i className='fa fa-times text-[#8b8b8b] text-[24px]'></i> </button>
                </div>
                <div>
                    <Link to="/casino" className='px-2.5 py-[5px] block'><img src={mobile_mrime1} className='w-full' /></Link>
                </div>
                <div>
                    <Link to="/slot" className='px-2.5 py-[5px] block'><img src={mobile_mrime2} className='w-full' /></Link>
                </div>
                <div>
                    <Link to="#" className='px-2.5 py-[5px] block'><img src={mobile_mrime3} className='w-full' /></Link>
                </div>
                <img src={sidebar_image} className='block my-2.5 mx-auto'></img>

            </div>
            <MobileSidebar isOpen={openMenuSidebar} referance={sideMenuRef} onClose={handleCloseMenuSidebar} />
        </>
    )
}

export default MobileNavbar